import styled from 'styled-components/macro';

export const Content = styled.div`
  padding: 20px 15px;
  position: relative;

  @media (min-width: 1200px) {
    padding: 20px;
  }
`;

export const ContentWrap = styled.div`
  flex-grow: 1;
  padding-left: 20px;
  position: relative;

  .content-overlay {
    position: absolute;
    inset: 0;
    background: rgba(32, 32, 32, 0.35);
    backdrop-filter: blur(2px);
    border-radius: 20px;
    left: 19px;
    z-index: 9;
  }
`;

export const FlexContainer = styled.main`
  display: flex;
  padding-top: 20px;
`;

export const Map = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  z-index: 1;

  iframe {
    width: 100%;
    height: 100%;
    border: 0;
    box-shadow: none;
  }
`;
